import styled from '@nfinite/react-hubstairs/styled'

export const Container = styled('div')`
  display: flex;
  & > svg {
    width: 100%;
    height: 100%;
  }
`
